import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IPractice } from "../Types";
import { Column, RowData } from "../components/MultiSiteTable";

export const useMultiSiteTable = (): { columns: Column<RowData>[] } => {
  const { t: translate } = useTranslation();
  const columns: Column<RowData>[] = [
    { key: "name", header: translate("MultiSiteList.SitesList.Heading.SiteName"), width: "300px" },
    { key: "postcode", header: translate("MultiSiteList.SitesList.Heading.Postcode"), width: "150px" },
    {
      key: "radius",
      header: translate("MultiSiteList.SitesList.Heading.Radius"),
      render: (value) => <span>{value as string | number}</span>
    },
    {
      key: "practices",
      header: translate("MultiSiteList.SitesList.Heading.Practices"),
      render: (value: IPractice[]): React.ReactNode => {
        return <span>{value && value.length ? value.length : "-"}</span>;
      }
    },
    {
      key: "included",
      header: translate("MultiSiteList.SitesList.Heading.Included"),
      render: (value) => value?.toLocaleString() || "-"
    },
    {
      key: "excluded",
      header: translate("MultiSiteList.SitesList.Heading.Excluded"),
      render: (value) => value?.toLocaleString() || "-"
    },
    {
      key: "population",
      header: translate("MultiSiteList.SitesList.Heading.Population"),
      render: (value) => value?.toLocaleString() || "-"
    }
  ];

  return {
    columns
  };
};
